import { render, staticRenderFns } from "./h-border.vue?vue&type=template&id=c6438fee&scoped=true&"
import script from "./h-border.vue?vue&type=script&lang=js&"
export * from "./h-border.vue?vue&type=script&lang=js&"
import style0 from "./h-border.vue?vue&type=style&index=0&id=c6438fee&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6438fee",
  null
  
)

export default component.exports